import tableContent from './tableRelatedSportRoomsMultiselectable';

export default {
  title: 'SportRooms',
  attributeName: 'sportRooms',
  getURL: 'mainHubs/mainHubId/roomsPaginated',
  noArea:true,
  noTitle:true,
  createURL: 'mainHubs/mainHubId/rooms',
  updateURL: 'mainHubs/mainHubId/rooms',
  removeURL: 'mainHubs/mainHubId/rooms',
  itemName: 'name',
  itemId: 'id',
  sessionParams: ['mainHubId'],
  tableConfig: tableContent,
  autoUpdate: true,

};